export default __webpack_public_path__ + "static/media/robert_duta.2cd4e741.png";